import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ToolkitProvider, { CSVExport, Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import { formatDateFr } from "../../lib/utils";
import { route } from "preact-router";
import { faEye, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "preact/hooks";
import { deleteCover } from "../../api/covers";
import { NotificationContext } from "../notification-provider";
import { ConfirmationModalContext } from "../../contexts/confirmation-modal";
import { Alert, Spinner } from "react-bootstrap";

export default function ProductCoverTable(props) {

    const [deleteCoverLoading, setDeleteCoverLoading] = useState(false);
    const { addNotification } = useContext(NotificationContext);
    const { showConfirmation } = useContext(ConfirmationModalContext);

    const removeCover = async (coverKey) => {

        let ok = await showConfirmation(`Supprimer la garantie ${coverKey} ?`, <>
            <Alert variant="danger">
                <p>Attention, cette action est irréversible.</p>
                <p>La garantie sera supprimée de façon permanente.</p>
            </Alert>
        </>, "Supprimer la garantie");

        if (!ok) {
            return;
        }

        setDeleteCoverLoading(coverKey);

        deleteCover(props.productKey, coverKey).then(() => {
            addNotification(`La garantie a été supprimée avec succès`, "success");
            if (typeof props.onChange === 'function') {
                props.onChange();
            }
        }).catch((err) => {
            addNotification("Erreur lors de la suppression de la garantie", "danger");
            console.error(err);
        }).finally(() => {
            setDeleteCoverLoading(false);
        });
    }

    const columns = [
        {
            dataField: "key",
            text: "#",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "name",
            text: "Nom",
            sort: true,
        },
        {
            dataField: "product_code",
            text: "Produit",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "position",
            text: "Position",
            sort: true,
            formatter: (cell, row) => {
                return <code>{cell}</code>
            }
        },
        {
            dataField: "created_at",
            text: "Créé à",
            sort: true,
            formatter: (cell, row) => {
                return formatDateFr(cell, true);
            }
        },
        {
            dataField: "actions",
            text: "Actions",
            formatter: (cell, row) => {
                return (
                    <>
                        <div className="btn-group" role="group" aria-label="Actions">
                            <button className="btn btn-sm btn-primary" onClick={(e) => {
                                e.stopPropagation();
                                editCover(e, row);
                            }}>
                                <FontAwesomeIcon icon={faPen} />
                            </button>

                            <button disabled={deleteCoverLoading === row.key} className="btn btn-sm btn-danger" onClick={(e) => {
                                e.stopPropagation();
                                removeCover(row.key);
                            }}>
                                <FontAwesomeIcon icon={faTrash} />
                                {deleteCoverLoading === row.key ? <Spinner animation="border" size="sm" /> : null}
                            </button>
                        </div>
                    </>
                )
            }
        }
    ];

    const editCover = (e, row, rowIndex) => {
        route(`/save-cover/${props?.productKey}/${row.key}`);
    }

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            editCover(e, row, rowIndex);
        }
    };

    return <>
        <ToolkitProvider keyField="key" data={props.covers} columns={columns}
            paginationFactory={paginationFactory({
                hidePageListOnlyOnePage: true,
                hideSizePerPage: true,
            })}
            search={
                {
                    searchFormatted: true,
                    placeholder: "Rechercher une garantie",
                    style: {
                        width: '100%'
                    }

                }
            }
            exportCSV>
            {(props) => (
                <>
                    <Search.SearchBar {...props.searchProps} placeholder="Rechercher une garantie" className="rounded-0 w-100" />
                    <BootstrapTable
                        rowStyle={{
                            cursor: 'pointer'
                        }}
                        rowClasses={(row, rowIndex) => {
                            return 'cursor-pointer animate__animated animate__fadeIn';
                        }} noDataIndication={<>
                            <div className="text-center d-flex flex-column align-items-center justify-content-center gap-2  p-4 text-muted">
                                <FontAwesomeIcon icon={faEye} size="2x" />
                                <p>Aucune garantie pour ce produit</p>
                            </div>
                        </>} rowEvents={rowEvents} classes={"align-middle"} bordered={false} striped hover {...props.baseProps} />
                </>
            )}
        </ToolkitProvider>
    </>
}